import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import _ from "lodash";
import { useDispatch, useSelector, connect } from "react-redux";
import { reduxForm, Field, initialize, formValueSelector } from "redux-form";
import { openModal, closeModal, fetchError } from "../../actions";
import { Form, Button, Grid, Menu, Container, Header } from "semantic-ui-react";
import { TextInput, FileInput, AdvertiserOptions } from "../utils/form-fields";
import { createBanner, updateBanner, uploadFile } from "../../firebase";
import { CancelButton } from "../utils/buttons";
import { checkUser } from "../utils/helpers";
import Loading from "../../app/loading";

let StandardForm = ({
  change,
  submitting,
  pristine,
  handleSubmit,
  invalid,
  retailer,
  fieldValues,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const banner = useSelector((state) => state.banner);
  const advertisers = useSelector((state) => state.advertisers || []);
  const user = useSelector((state) => state.user);
  const template = useSelector((state) => state.template);

  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    const { pathname } = location;
    const arr = pathname.split("/");
    if (
      !arr.find((path) => {
        return path === "new";
      })
    ) {
      if (!checkUser(user, banner.advertiser, retailer)) navigate("/");
    }
  }, [navigate, user, banner.advertiser, retailer, location]);

  useEffect(() => {
    //if (template.fields) {
    banner.fields = banner.fields || {};
    dispatch(initialize("standardForm", banner));
    //}
    setShowLoading(false);
  }, [dispatch, banner, template]);

  const getAdvertiser = (advertiser) => {
    return _.find(advertisers, (item) => {
      return item.displayName === advertiser;
    });
  };

  const handleChange = (e, { value, name }) => {
    change(name, value);
  };

  const handleFileUpload = (
    file,
    key,
    title,
    width,
    height,
    maxWidth,
    density
  ) => {
    //if (!size) size = "";
    let folder = banner.key || key;
    if (file.type.indexOf("image/") === -1) {
      return dispatch(
        fetchError({
          name: "Upload error",
          error: "Wrong file type. Please upload an image - jpg, gif or png",
        })
      );
    }
    uploadFile(file, folder, (data) => {
      dispatch(
        openModal("ProgressModal", {
          size: "tiny",
          progress: data.progress,
          name: file.name,
          title,
          centered: false,
        })
      );
      if (data.progress === 100) {
        change(key, {
          name: data.name,
          path: data.path,
          width: width,
          height: height,
          maxWidth: maxWidth,
          density,
        });
        //window.setTimeout(() => dispatch(closeModal()), 1000);
        dispatch(closeModal());
      }
      if (data.error) {
        dispatch(
          openModal("ErrorModal", {
            size: "tiny",
            centered: false,
            error: {
              name: file.name,
              error: "Image error",
              reason: "File size too large or dimensions are wrong",
            },
          })
        );
      }
    });
  };

  const validateImageSize = (e, values, key) => {
    e.persist();
    const timesBy = {
      ONE_TO_ONE: 1,
      TWO_TO_ONE: 2,
      THREE_TO_TWO: 1.5,
    };
    const { target } = e;
    target.classList.add("adaptive-form-image");
    target.parentElement.classList.remove("warning");
    const valid =
      target.offsetWidth === values.width * timesBy[values.density]
        ? "valid"
        : "warning";
    target.parentElement.classList.add(valid);
    target.classList.remove("adaptive-form-image");
  };

  const handleSubmitForm = async (values) => {
    setShowLoading(true);
    let advertiserId = await getAdvertiser(values.advertiser);
    advertiserId = advertiserId.advertiserId;
    let templateType = "standard";
    let bannerType = banner.bannerType || template.name;
    let currentUser = `${user.displayName} (${user.organisation})`;
    const submitValues = {
      ...values,
      bannerType,
      currentUser: false,
      retailer,
      advertiserId,
      templateType,
      service: template.service,
    };
    submitValues.lastModBy = currentUser;
    //return console.log(submitValues);
    banner.key
      ? updateBanner(submitValues, banner.key, dispatch).then((message) => {
          setShowLoading(false);
        })
      : createBanner(submitValues, dispatch)
          .then((message) => {
            if (message.id) navigate(`/${retailer}/banner/${message.id}`);
            console.log(message);
          })
          .catch((error) => console.log(error));
  };

  if (showLoading) return <Loading />;

  return (
    <Form onSubmit={handleSubmit(handleSubmitForm)}>
      <Grid padded className="trade-form">
        <Grid.Row>
          <Grid.Column computer={4} tablet={8} mobile={16}>
            <Header as="h3">Banner info</Header>
            <Field
              name="bannerTitle"
              label="Title"
              type="text"
              component={TextInput}
              placeholder="Add a banner title"
              isRequired={true}
            />
            <Field
              name="adNumber"
              label="Ad number"
              type="text"
              component={TextInput}
              placeholder="Add an ad number"
              isRequired={true}
            />
            <div className="field">
              <div className="field">
                <label htmlFor="advertiser">Advertiser</label>
                <Field
                  name="advertiser"
                  component="select"
                  multiple={false}
                  className="ui selection dropdown"
                >
                  {!user.restrictByAdvertiser && (
                    <option value="">Choose an advertiser</option>
                  )}
                  <AdvertiserOptions advertisers={advertisers} />
                </Field>
              </div>
            </div>
            <Field
              name="bannerURL"
              label="Banner link"
              type="text"
              component={TextInput}
              placeholder="Add a URL link"
              isRequired={true}
            />
          </Grid.Column>
          <Grid.Column computer={4} tablet={8} mobile={16}>
            <Header as="h3">ALT text</Header>
            <Field
              name="alt"
              label="Banner ALT text"
              type="text"
              component={TextInput}
              placeholder="Add ALT text"
              isRequired={true}
            />
            <Header as="h3">Images</Header>
            {_.map(template.fields, (field, index) => (
              <div className="field imagelist" key={field.name}>
                <label>{field.label}</label>
                {fieldValues[field.name] && fieldValues[field.name].path && (
                  <img
                    src={fieldValues[field.name].path}
                    alt={field.label}
                    onLoad={(e) => {
                      validateImageSize(e, fieldValues[field.name], field.name);
                    }}
                    className="adaptive-form-image"
                  />
                )}
                <Field
                  name={`fields.${field.name}`}
                  component={FileInput}
                  fileName={
                    fieldValues[field.name] && fieldValues[field.name].name
                      ? fieldValues[field.name].name
                      : ""
                  }
                  callback={(file) =>
                    handleFileUpload(
                      file,
                      `fields.${field.name}`,
                      field.label,
                      field.width,
                      field.height,
                      field.maxWidth,
                      field.density
                    )
                  }
                  handleFileRemove={(e) => change(`fields.${field.name}`, {})}
                />
                {fieldValues[field.name] && fieldValues[field.name].density && (
                  <Form.Group inline>
                    <Form.Radio
                      label="1x density"
                      value="ONE_TO_ONE"
                      name={`fields.${field.name}.density`}
                      checked={fieldValues[field.name].density === "ONE_TO_ONE"}
                      onChange={handleChange}
                    />
                    <Form.Radio
                      label="1.5x density"
                      value="THREE_TO_TWO"
                      name={`fields.${field.name}.density`}
                      checked={
                        fieldValues[field.name].density === "THREE_TO_TWO"
                      }
                      onChange={handleChange}
                    />
                    <Form.Radio
                      label="2x density"
                      value="TWO_TO_ONE"
                      name={`fields.${field.name}.density`}
                      checked={fieldValues[field.name].density === "TWO_TO_ONE"}
                      onChange={handleChange}
                    />
                  </Form.Group>
                )}
                <span className="warning-text">
                  The image size is the wrong size or it has the wrong density
                  setting{" "}
                </span>
              </div>
            ))}
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Menu fixed="bottom" size="mini">
        <Container>
          <Menu.Item>
            <Button
              disabled={submitting || pristine || invalid || showLoading}
              positive
              type="submit"
              loading={showLoading}
              size="mini"
            >
              Save
            </Button>
          </Menu.Item>
          <Menu.Item>
            <CancelButton
              id={banner.key}
              location={location}
              retailer={retailer}
              pristine={pristine}
              size="mini"
            />
          </Menu.Item>
        </Container>
      </Menu>
    </Form>
  );
};

const validate = (values) => {
  const isUrlValid = (url) => {
    return url.match(
      /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
    );
  };

  const hasWhiteSpace = (hex) => {
    return hex.match(/\s/g);
  };

  const errors = { fields: {} };

  if (!values.bannerTitle) {
    errors.bannerTitle = "Please enter a title";
  }
  if (!values.adNumber || isNaN(Number(values.adNumber))) {
    errors.adNumber = "Please enter a number only";
  }
  if (!values.advertiser) {
    errors.advertiser = "Please select an advertiser";
  }
  if (values.bannerURL) {
    if (!isUrlValid(values.bannerURL)) {
      errors.bannerURL = "Please enter a valid URL";
    }
    if (isUrlValid(values.bannerURL)) {
      if (hasWhiteSpace(values.bannerURL)) {
        errors.bannerURL = "Please remove any spaces";
      }
    }
  }

  return errors;
};

StandardForm = reduxForm({
  validate,
  form: "standardForm",
})(StandardForm);

const selector = formValueSelector("standardForm");
let fieldValues = {};
StandardForm = connect((state) => {
  const advertiserValue = selector(state, "advertiser");
  if (state.template.fields) {
    state.template.fields.map((field) => {
      return (fieldValues = {
        ...fieldValues,
        [field.name]: selector(state, `fields.${field.name}`),
      });
    });
  }
  return {
    advertiserValue,
    fieldValues,
  };
})(StandardForm);

export default StandardForm;
